import { render, staticRenderFns } from "./UnidadesCard.vue?vue&type=template&id=f597a2a0&scoped=true"
import script from "./UnidadesCard.vue?vue&type=script&lang=js"
export * from "./UnidadesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597a2a0",
  null
  
)

export default component.exports